import React from "react";
import { IForm } from "../../../../types/form.type";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import ModalForm from "../../modal/ModalForm";
import { Stack } from "@mui/material";
import { generateRandomString } from "../../../../utils/helpers";
import InfoSection from "./info-section/InfoSection";
import VoucherSection from "./voucher-section/VoucherSection";
import moment from "moment";

const schema = yup.object({
  ma: yup.string().required("Vui lòng nhập mã đặt chỗ"),
});

function FormTicketOrder({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();
  const defaultData: { [key: string]: any } = {
    // thong tin ve
    ma: "",
    hang_ve: null,
    date_created: moment().format("YYYY-MM-DD HH:mm"),
    tg_khoi_hanh: null,
    ten_kh: "",
    sdt_kh: "",
    route: null,
    nha_xe: null,
    loai_xe: null,
    xe_khach: null,
    ma_ghe: "",
    dien_giai: "",
    gia_ban_nt: 0,
    so_luong: 1,
    tien_hang_nt: 0,
    tien_ck_nt: 0,
    tien_tt_nt: 0,
    trang_thai: null,
    pt_thanh_toan: "",
    // thong tin voucher
    hieu_luc_tu: moment().format("YYYY-MM-DD"),
    hieu_luc_den: moment().add(5, "days").format("YYYY-MM-DD"),
    so_tien: 0,
    ty_le: 0,
    so_tien_max: 0,
    status: true,
  };
  const originData = defaultValues
    ? {
        ...defaultData,
        ...defaultValues,
        nha_xe: defaultValues?.nha_xe
          ? {
              ma_dt: defaultValues?.nha_xe || "",
              ten_dt: defaultValues?.ten_nha_xe || "",
            }
          : null,
        xe_khach: defaultValues?.xe
          ? {
              _id: defaultValues?.xe,
              name: defaultValues?.ten_xe,
              bien_so: defaultValues?.bien_so,
              ten_nha_xe: defaultValues?.ten_nha_xe,
            }
          : null,
        hang_ve: defaultValues?.hang_ve
          ? {
              ma: defaultValues?.hang_ve,
              ten: defaultValues?.ten_hang_ve,
            }
          : null,
        loai_xe: defaultValues?.loai_xe
          ? {
              _id: defaultValues?.loai_xe,
              name: defaultValues?.ten_loai_xe,
            }
          : null,
        route: defaultValues?.route
          ? {
              _id: defaultValues?.route,
              name: defaultValues?.route_name,
            }
          : null,
        trang_thai: defaultValues?.trang_thai
          ? {
              ma_trang_thai: defaultValues?.trang_thai || "",
              ten_trang_thai: defaultValues?.ten_trang_thai || "",
            }
          : null,
      }
    : defaultData;

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    control,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const handleReset = () => {
    reset(originData);
  };

  const generateDataPost = async (values: typeof defaultData) => {
    const {
      ma,
      nha_xe,
      xe_khach,
      hang_ve,
      loai_xe,
      route,
      trang_thai,
      ...fields
    } = values;
    const randomMa = ma || generateRandomString(8);

    return {
      ...fields,
      ma: randomMa,
      ten: randomMa,
      nha_xe: nha_xe?.ma_dt || "",
      ten_nha_xe: nha_xe?.ten_dt || "",

      xe: xe_khach?._id || "",
      ten_xe: xe_khach?.bien_so || "",
      bien_so: xe_khach?.bien_so || "",

      hang_ve: hang_ve?.ma || "",
      ten_hang_ve: hang_ve?.ten || "",
      loai_xe: loai_xe?._id || "",
      ten_loai_xe: loai_xe?.name || "",
      route: route?._id || "",
      route_name: route?.name || "",
      trang_thai: trang_thai?.ma_trang_thai || "1",
    };
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="900px"
      formTitle="vé"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Stack gap={2}>
        <InfoSection
          isEdit={isEdit}
          control={control}
          register={register}
          watch={watch}
          setValue={setValue}
          errors={errors}
        />
        <VoucherSection control={control} register={register} />
      </Stack>
    </ModalForm>
  );
}

export default FormTicketOrder;
